import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import { SET_PATIENT_ACTIVE_CPP_TASKS, SET_PATIENT_ALL_CPP_TASKS, UPDATE_WEEKLY_TASKS, SET_WEEKLY_TASKS } from './constants';
const initialState = {
  patientActiveCPPTasks: null,
  patientAllCPPTasks: {},
  updateWeeklyTasks: 0,
  dispatchTask: null,
  weeklyTasks: null
};
const initTaskGlobalContext = {
  patientActiveCPPTasks: null,
  patientAllCPPTasks: {},
  updateWeeklyTasks: 0,
  dispatchTask: null,
  weeklyTasks: null
};
export const TaskGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    // CPP, Visit
    case SET_PATIENT_ACTIVE_CPP_TASKS:
      newState.patientActiveCPPTasks = action.payload;
      break;

    case SET_PATIENT_ALL_CPP_TASKS:
      newState.patientAllCPPTasks = action.payload;
      break;

    case UPDATE_WEEKLY_TASKS:
      newState.updateWeeklyTasks += 1;
      break;

    case SET_WEEKLY_TASKS:
      newState.weeklyTasks = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const TaskGlobalContext = /*#__PURE__*/createContext(initTaskGlobalContext);
export const TaskGlobalDispatchContext = /*#__PURE__*/createContext({});
export const TaskGlobalContextConsumer = TaskGlobalContext.Consumer;
export const TaskGlobalDispatchContextConsumer = TaskGlobalDispatchContext.Consumer;
export const TaskGlobalContextProvider = ({
  agency,
  patient,
  observation,
  siteId,
  children
}) => {
  const [{
    patientActiveCPPTasks,
    patientAllCPPTasks,
    updateWeeklyTasks,
    weeklyTasks
  }, dispatch] = useReducer(TaskGlobalContextReducer, initialState);

  const getWeeklyTasks = async () => {
    if (patient && agency && siteId && observation) {
      const weeklyTasksRes = await observation.getPatientWeeklyTasks(agency, siteId, patient.patientNumber);
      dispatch({
        type: SET_WEEKLY_TASKS,
        payload: weeklyTasksRes
      });
    }

    return null;
  };

  useEffect(() => {
    // if tasks get created in CPP widget, get the update
    // if task get saved in visit widget, get the update
    if (updateWeeklyTasks) {
      getWeeklyTasks();
    }
  }, [updateWeeklyTasks]);
  const context = useMemo(() => ({
    patientActiveCPPTasks,
    patientAllCPPTasks,
    updateWeeklyTasks,
    weeklyTasks,
    dispatchTask: dispatch
  }), [patientActiveCPPTasks, patientAllCPPTasks, updateWeeklyTasks, weeklyTasks, dispatch]);
  return /*#__PURE__*/React.createElement(TaskGlobalContext.Provider, {
    value: context
  }, children);
};
export function withTaskGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(TaskGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(TaskGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default TaskGlobalContext;